import React from 'react'
import { Button } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'
import { useParams } from 'react-router-dom'
import { convertToFormData, sweetAlert } from '../../../utils'
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService'
import { responseError } from '../../../helpers/responseHandler'

const StepFour = ({ setActiveStep, params, isEdit, setIsEdit }) => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()
  const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()

  const onSubmit = async data => {
    const newForm = { step_no: '5', ...data }
    setIsEdit(prev => {
      return { ...prev, ...newForm }
    })
    await editRequest({ params, newForm })
      .unwrap()
      .then(res => {
        setActiveStep(4)
        if (res?.status) {
          sweetAlert(res?.message, 'success')
        }
        // if (res?.errors) {
        //     Object.entries(res?.errors)?.forEach(([key, value]) => {
        //         sweetAlert(value[0], 'error')
        //     })
        // }
      })
      .catch(err => {
        responseError(err)
      })
  }

  return (
    <>
      <div className='row justify-content-center'>
        <div className='col-xl-9'>
          <div className='card custom-card'>
            <div className='card-body'>
              <h5 className='text-center'>Employment History</h5>
              <div className='row'>
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className='col-md-12'
                  id='application-status'
                >
                  <div className='row'>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Employer Name (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.employer_name`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.name || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder='Enter Employer Name'
                              {...field}
                              isInvalid={errors.employment_history?.[0]?.employer_name}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Job Title (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.job_title`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.job_title || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder='Enter Job Title'
                              {...field}
                              isInvalid={errors.employment_history?.[0]?.job_title}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Start Date (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.start_date`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.start_date || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='date'
                              placeholder='Enter Start Date'
                              {...field}
                              isInvalid={errors.employment_history?.[0]?.start_date}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>End Date (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.end_date`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.end_date || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='date'
                              placeholder='Enter End Date'
                              {...field}
                              isInvalid={errors.employment_history?.[0]?.end_date}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Reason for Leaving (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.reason_for_living`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.reason_for_living || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder='Enter Reason for Leaving'
                              {...field}
                              isInvalid={errors.employment_history?.[0]?.reason_for_living}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Pre-Employment Drug Test Date (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.pre_employment_drug_test_date`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.drug_test_date || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='date'
                              placeholder='Enter Pre-Employment Drug Test Date'
                              {...field}
                              isInvalid={
                                errors.employment_history?.[0]?.pre_employment_drug_test_date
                              }
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-12'>
                      <Form.Group className='mb-3'>
                        <Form.Label>References (Optional):</Form.Label>
                        <Controller
                          name={`employment_history.0.References`}
                          control={control}
                          defaultValue={isEdit?.employment_history?.[0]?.references || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              as='textarea'
                              rows={3}
                              placeholder='Enter References'
                              {...field}
                              isInvalid={errors.employment_history?.[0]?.References}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className='col-lg-4 d-flex mb-3'>
                  <Button
                    variant='secondary'
                    className='mt-auto w-100'
                    onClick={() => setActiveStep(2)}
                  >
                    Previous
                  </Button>
                </div>
                {/* <div className="col-lg-4 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(4)}
                                    >
                                        Next
                                    </Button>
                                </div> */}
                <div className='col-lg-3 d-flex mb-3'>
                  <LoadingButtonWithForm
                    isLoading={editLoading}
                    name='Next & Save'
                    form='application-status'
                    className='text-white mt-auto w-100'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StepFour
